// layout
export { default as CardIcon } from "./layout/card.svg";
export { default as CartIcon } from "./layout/cart.svg";
export { default as HeartIcon } from "./layout/heart.svg";
export { default as Heart2Icon } from "./layout/heart2.svg";
export { default as MailIcon } from "./layout/mail.svg";
export { default as PhoneIcon } from "./layout/phone.svg";
export { default as UserIcon } from "./layout/user.svg";
export { default as RightArrow } from "./layout/right-arrow.svg";
export { default as LeftArrow } from "./layout/left-arrow.svg";
export { default as TriangleRight } from "./layout/triangle-right.svg";
export { default as UploadIcon  } from "./layout/upload.svg";
export { default as DeleteIcon  } from "./layout/delete.svg";
export { default as PencilIcon  } from "./layout/pencil.svg";
export { default as HelpCircle  } from "./layout/help-circle.svg";

// Logo
export { default as Logo } from "./logo/logo.svg";
export { default as Logo2 } from "./logo/logo2.svg";
export { default as Logo3 } from "./logo/logo3.svg";
export { default as Logo4 } from "./logo/logo4.svg";
// Home
export { default as BoxReturnIcon } from "./home/box-return.svg";
export { default as DollarSignIcon } from "./home/dollar-sign.svg";
export { default as WarrantyIcon } from "./home/warranty.svg";

// Brands
export { default as AlutecLogo } from "./brands/Frame 2147225512.svg";
export { default as BbsLogo } from "./brands/bbs.svg";
export { default as ContinentalLogo } from "./brands/continental.svg";
export { default as EnkeiLogo } from "./brands/Frame 2147225514.svg";
export { default as HankookLogo } from "./brands/hankook.svg";
export { default as OzLogo } from "./brands/oz.svg";
export { default as PirelliLogo } from "./brands/pirelli.svg";

// About
export { default as Award } from "./about/award.svg";
export { default as Shield_tick } from "./about/shield-tick.svg";
export { default as flash_circle } from "./about/flash-circle.svg";
export { default as profile_user } from "./about/profile-user.svg";

// how-it-works
export { default as DollarCircle } from "./how-it-works/dollar-circle.svg";
export { default as CheckOut } from "./how-it-works/check-out.svg";

// shipping
export { default as TruckIcon } from "./shipping/truck.svg";
export { default as PackageIcon } from "./shipping/package.svg";
export { default as TickIcon } from "./shipping/tick.svg";
export { default as HomeIcon } from "./shipping/home.svg";
export { default as LocationIcon } from "./shipping/location.svg";
export { default as PackageCheckIcon } from "./shipping/package-check.svg";
export { default as PaymentIcon } from "./shipping/payment.svg";

// contact
export { default as InboxIcon } from "./contact/inbox.svg";
export { default as Phone1Icon } from "./contact/phone.svg";
export { default as PinLocationIcon } from "./contact/pin-location.svg";